import { TranslocoPipe } from '@jsverse/transloco';
import { ChangeDetectorRef, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { ColumnDirective, DialogComponent, TableComponent, TooltipTextComponent } from 'vcp-common-ui-lib';
import { ReferenceTaskTypePipe } from '../../pipe/status.pipe';
import { ITaskModel } from '../../model/task.model';
import { IMilestoneModel } from '../../model/milestone.model';

@Component({
    selector: 'vc-assessment-milestone-task-dialog',
    templateUrl: './assessment-milestone-task-dialog.component.html',
    styleUrls: ['./assessment-milestone-task-dialog.component.scss'],
    imports: [
        TranslocoPipe,
        DialogComponent,
        TableComponent,
        ColumnDirective,
        TooltipTextComponent,
        ReferenceTaskTypePipe,
    ],
})
export class AssessmentMilestoneTaskDialogComponent {
    private readonly _changeDetectorRef: ChangeDetectorRef = inject(ChangeDetectorRef);

    @Input()
    tasks!: Array<ITaskModel>;

    @Input()
    set milestone(value: IMilestoneModel) {
        setTimeout(() => {
            if (this.tasks && value?.tasks) {
                value.tasks = this._renderTasks(value.tasks);
            }
            this._milestone = value;
            this._changeDetectorRef.markForCheck();
        }, 0);
    }
    get milestone(): IMilestoneModel {
        return this._milestone;
    }
    private _milestone!: IMilestoneModel;

    @Input()
    set visible(value: boolean) {
        if (this._visible != value) {
            this._visible = value;
            this.visibleChange.emit(this._visible);
        }
    }
    get visible(): boolean {
        return this._visible;
    }
    private _visible: boolean = false;

    @Output()
    visibleChange = new EventEmitter<boolean>();

    private _renderTasks(tasks: ITaskModel[]): ITaskModel[] {
        return tasks.map((task: ITaskModel) => {
            const match = this.tasks.find((assessmentTask: ITaskModel) => task.id === assessmentTask.id);
            if (match) {
                return match;
            }
            return task;
        });
    }
}
